import { queryOptions } from "@tanstack/react-query"
import {
  buildProductReviewPermissionQueryKey,
  buildProductReviewsQueryKey,
  getProductReviewPermission,
  getProductReviews,
} from "@/api/product-reviews"

export const getProductReviewsQueryOptions = (productId: number) =>
  queryOptions({
    queryKey: buildProductReviewsQueryKey(productId),
    queryFn: () => getProductReviews(productId),
    staleTime: 60_000,
  })

export const getProductReviewPermissionQueryOptions = (productId: number) =>
  queryOptions({
    queryKey: buildProductReviewPermissionQueryKey(productId),
    queryFn: () => getProductReviewPermission(productId),
    staleTime: 30_000,
  })
